import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/[[slug]]/p/[id].tsx';
defineClientComponent('[[slug]]/p/[id]', Component);